module.exports = __webpack_public_path__ + "media/assets/images/category/Random@2x-58b91040fa428adcb2132a192d37e65f.png";